import styled from 'styled-components';

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 15px;
    @media only screen and (max-width: 767px) {
      text-align: center;
      justify-content: center;
      margin-top: -15px;
    }
  }

  .column {
    @media only screen and (max-width: 767px) {
      margin-top: 120px;
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);
`;
